import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class MeasurerId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): MeasurerId {
    return new MeasurerId(value);
  }
}
